/**
 * Check the difference between two objects and return the difference robustly
 * @param {*} currentFormData
 * @param {*} originalFormData
 * @returns
 */
export default function checkDifference(currentFormData, originalFormData) {
    try {
        if (typeof currentFormData !== 'object' || typeof originalFormData !== 'object') {
            throw new Error('Both arguments must be objects');
        }

        const diff = {};
        Object.keys(currentFormData).forEach((key) => {
            if (
                Object.hasOwn(currentFormData, key) &&
                Object.hasOwn(originalFormData, key) &&
                currentFormData[key] !== originalFormData[key]
            ) {
                diff[key] = currentFormData[key];
            }
        });
        return diff;
    } catch (error) {
        console.log('Error in checkDifference: ', error);
        throw error;
    }
}
